import * as jwtDecode from "jwt-decode";

export const authToken = {
  Query: {
    authToken: () => {
      try {
        const token = localStorage.getItem("token") || "";
        const decoded = jwtDecode(token);
        console.log(decoded);
        return {
          ...decoded,
          token: token,
          __typename: "AuthToken"
        };
      } catch (e) {
        console.log(e);
        return null;
      }
    }
  },
  Mutation: {
    updateAuthToken: (_: object, { token }: TokenParams) => {
      localStorage.setItem("token", token);
      return null;
    }
  }
};

export interface TokenParams {
  token: string;
}

export interface TokenQuery {
  authToken: AuthToken | null;
}

export interface AuthToken {
  __typename: "AuthToken";
  token?: string | null;
  email?: string | null;
  exp?: Number | null;
  iat?: Number | null;
  id?: string | null;
  name?: string | null;
  scopes?: Array<string> | null;
}



// WEBPACK FOOTER //
// ./src/resolvers/authToken.ts